var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_c('add-new-user-guide',{attrs:{"info":_vm.info,"name":_vm.name,"isEdit":true},on:{"fetch":_vm.complete,"close":_vm.handleclsoe}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }